<partial-loading-indicator class="m-wallet-balances_loading" #loadingEl>

    <div class="m-wallet-balances_inside-loading">
        <div class="m-wallet-balances_inside-loading_headers">
            <div class="m-wallet-balances_inside-loading_headers-cell">
                {{ 'components.mobile.wallet-page.column_assets' | l10n }}
            </div>
            <div class="m-wallet-balances_inside-loading_headers-cell -values">
                {{ 'components.mobile.wallet-page.column_amount' | l10n }}
            </div>
        </div>
        <div class="m-wallet-balances_inside-loading_body">
            <div class="m-wallet-balances_list-container" customScrollbar>

                @let isFreshFetching = $isFreshFetching();
                @if ($rows().length) {
                    @for (row of $rows(); track row.key) {
                        @let animationCls = $safeNavigationMigration(row.values?.qty) | valueChangeAnimation:true:isFreshFetching;

                        <div class="m-wallet-balances_list-row" [ngClass]="animationCls">
                            <div class="m-wallet-balances_list-cell">
                                <dyn-display-asset [ngClass]="animationCls" [displayAsset]="row.displayAsset"></dyn-display-asset>
                            </div>

                            <div class="m-wallet-balances_list-cell -values">
                                <div class="m-wallet-balances_list-cell_value">
                                    <span [displayDecimal]="$safeNavigationMigration(row.values?.qty) | bigintDisplayDecimal:row.displayAsset.deliverable.decimalPlaces"
                                          [isZeroWithoutDecimals]="true"
                                          [ngClass]="animationCls">
                                    </span>
                                </div>
                            </div>
                        </div>
                    }
                } @else if ($isEmptyBalances()) {
                    <div class="m-wallet-balances_list-empty-msg">
                        {{ 'components.widgets.wallet-widget.no_balance_info' | l10n }}
                    </div>
                }
            </div>
        </div>
    </div>

</partial-loading-indicator>
